import moment from 'moment'

//generic helper methods are declared here
export const generalHelperMethodsMixin = {
  methods: {
    /*get commonly needed values methods*/

    getWeekNumber(date) {
      if (!date) {
        return moment(new Date()).diff(moment(this.getStartDateOfProject), 'weeks')
      }

      return moment(new Date(date)).diff(moment(new Date(this.getStartDateOfProject)), 'weeks')
    },

    findFetchedDataIndexById(id) {
      return this.fetchedData.findIndex((x) => x.id === id)
    },

    /*sorting methods*/

    sortByDateDesc(dataObject) {
      dataObject.data.sort((a, b) => {
        const dateA = new Date(a[dataObject.dateColumn])
        const dateB = new Date(b[dataObject.dateColumn])
        return dateB - dateA
      })
    },

    sortUserByLastName(data) {
      data.sort((a, b) => {
        return a.user.last_name.localeCompare(b.user.last_name)
      })
    },

    /*formating methods*/

    async mapUserIdToName() {
      const response = await this.getUsersPromise()

      response.data.forEach((element) => {
        this.idToName[element.user.id] = `${element.user.first_name} ${element.user.last_name}`
      })
    },

    mapVisibilityIntToString(visibility) {
      return visibility == 0 //eslint-disable-line
        ? 'VISIBILITY.ONLY_ME'
        : visibility == 1 //eslint-disable-line
        ? 'VISIBILITY.SUPERVISORS_ONLY'
        : 'VISIBILITY.SUPERVISORS_AND_STUDENTS' //eslint-disable-line
    },

    returnAsFormatedMoment(date) {
      return moment(date).format('DD/MM/YYYY - HH:mm')
    },

    formatWorkReportDate(date) {
      const isToday = moment(date).isSame(moment(), 'day')
      if (isToday) {
        return moment(date).format('DD/MM/YYYY - HH:mm')
      }
      return moment(date).format('DD/MM/YYYY')
    },

    findOptionTextByValue(option, value) {
      return option.find((element) => element.value === value).text
    },

    /*array helper methods*/

    //checks a one dimensional array for duplicates
    arrayHasDuplicates(arr) {
      const unique = arr.filter(this.onlyUnique)

      return unique.length < arr.length
    },

    onlyUnique(value, index, self) {
      return self.indexOf(value) === index
    },

    getRoleName(roleId) {
      const role = this.roles.find((role) => role.id === roleId)
      return role ? role.label : ''
    }
  }
}
